/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_portada.mp4'
import img_fondo from '../../../Recursos/img_fondo.png'
import {Typewriter} from 'react-simple-typewriter'
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const navigate = useNavigate();
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <video width={'100%'} height={sCell ? 480 : 640}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       //   backgroundImage: `url(${img_fondo})`,
                       backgroundPosition: 'center',
                       backgroundSize: 'cover'
                   }}
                   id="background-video" autoPlay loop muted poster={img_fondo}>

                <source src={fondo} type="video/mp4"/>

            </video>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    marginTop: sCell ? -60 : -82,
                    zIndex: 2,
                    background: `radial-gradient(204.38% 73.85% at 49.35% 50%, rgba(0, 0, 0, 0.00) 0%, #000 100%, rgba(0, 0, 0, 0.00) 100%)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: sCell ? 480 : 656
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', maxWidth: '1400px', px: 3}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 10}}
                        sx={{py: sCell ? 3 : 8}}
                    >


                        <Grid container size={{xs: 12, sm: 8, md: 7}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 4}}>
                            <Typography
                                component={'h1'}
                                sx={{
                                    color: '#fff',
                                    fontSize: sCell ? 32 : 52,
                                    fontWeight: 800,
                                    lineHeight: 1.1,
                                    textAlign: sCell ? 'left' : 'left',
                                    height: 150
                                }}>
                                <span style={{color: '#fff'}}>
                                <Typewriter
                                    words={['Reconocidos por nuestras empanadas irresistibles']}
                                    cursor={false}

                                />
                                </span>


                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 8, md: 8}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? -1 : 6}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 400, color: '#fff'}}>
                                Preparadas con sabor y amor. Visítanos
                                y
                                descubre por qué nuestros clientes siempre regresan.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Button
                                onClick={() => navigate('/Locales')}
                            >Ver Locales</Button>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Portada    